import { render, staticRenderFns } from "./v-chat-bubble-file.vue?vue&type=template&id=1941e965&scoped=true&"
var script = {}
import style0 from "./v-chat-bubble-file.vue?vue&type=style&index=0&id=1941e965&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941e965",
  null
  
)

export default component.exports